import React from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import {
  fetchData,
  setSelected,
} from '../../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsActions';
import { PlanForm } from '../PlanForm/PlanForm';
import { FormValues, NEW_PLAN_FORM_ID } from '../PlanForm/PlanForm.meta';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { useNewPlanMutation } from '../../api/useNewPlanMutation';
import { queryKeys } from '../../api/queryKeys';
import { useRouteParams } from '../../hooks/useRouteParams';

interface Props {
  closeModal: () => void;
}

export const NewPlanModal: React.FC<Props> = ({ closeModal }) => {
  const { mutateAsync: newPlan, isLoading: isCreatingNewPlan } = useNewPlanMutation();

  const queryClient = useQueryClient();

  const { clientId } = useRouteParams();

  const dispatch = useDispatch();

  const handleNewPlan = async ({ name, description }: FormValues) => {
    try {
      const newPlanId = await newPlan({
        name,
        description,
        clientId,
      });

      //  TODO (LEGACY): Remove after the migration is complete
      dispatch(
        fetchData(clientId, () => {
          dispatch(setSelected(newPlanId, clientId));
        }),
      );

      queryClient.invalidateQueries(queryKeys.proposedPlans(clientId));

      toast.success('New plan created successfully.');
    } catch (err) {
      toast.error('An error occurred. Please try again later.');
    }

    closeModal();
  };

  return (
    <Modal
      isOpen
      onRequestClose={closeModal}
      aria={{ labelledby: 'plan-selection--new-plan-modal-heading' }}
    >
      <ModalHeader id="plan-selection--new-plan-modal-heading">Create New Plan</ModalHeader>

      <ModalCloseButton disabled={isCreatingNewPlan} onClick={closeModal} />

      <ModalBody>
        <PlanForm formId={NEW_PLAN_FORM_ID} onSubmit={handleNewPlan} />
      </ModalBody>

      <ModalFooter>
        <Box display="flex" justifyContent="flex-end">
          <Button disabled={isCreatingNewPlan} variant="subtleInactive" onClick={closeModal}>
            Cancel
          </Button>

          <Button type="submit" isLoading={isCreatingNewPlan} ml="12" form={NEW_PLAN_FORM_ID}>
            Create New Plan
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
